import { render, staticRenderFns } from "./Footer3.vue?vue&type=template&id=700f859f&scoped=true"
import script from "./Footer3.vue?vue&type=script&lang=js"
export * from "./Footer3.vue?vue&type=script&lang=js"
import style0 from "./Footer3.vue?vue&type=style&index=0&id=700f859f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f859f",
  null
  
)

export default component.exports